import Journeys from '@/pages/journeys';
import { createFileRoute } from '@tanstack/react-router';

// Catch-all for billing sub-paths whose native tab hasn't been migrated yet (SPE-3765–3770).
// Without it, the `/settings/billing` layout (which only has an index child) surfaces a not-found
// for e.g. `/settings/billing/your-plan` instead of resolving. With the flag OFF, `BillingRoute`
// short-circuits to the embedded Ember host before this renders (the full Ember page serves the
// URL); with the flag ON, this hands the unmatched sub-path to the embedded host inside the shell
// until the tab's own route replaces this match.
export const Route = createFileRoute('/_authenticated/settings/billing/$')({
  component: Journeys,
});
